export const WIDGET_LABEL_SIZE = {
    primary: 20,
    secondary: 15,
};
